module.exports = __webpack_public_path__ + "static/media/true-digital-thickness-lens.51c30723.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueDigital/true-digital-thickness-lens.png
// module id = 3579
// module chunks = 0